import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AuthService} from "../../../shared/services/auth.service";
import {RewardService} from "../../../shared/services/reward.service";
import {RewardsSummaryService} from "../../../shared/services/rewards-summary.service";
import {ParamService} from "../../../shared/services/param.service";
import {properties} from '../../../../environments/properties';

@Component({
    selector: 'app-loyalty-promotions',
    templateUrl: './loyalty-promotions.component.html',
    styleUrls: ['./loyalty-promotions.component.scss']
})
export class LoyaltyPromotionsComponent implements OnInit {

    currentEnvironment: string;
    userInfo: any;
    appHostURL: any;
    banner: any;
    public isLoggedInTokenValid = false;
    public loading = true;
    selectedBanner: any;
    partnerOfferDeals = [];
    isCollapsed = false;
    private _input: string = '';
    private _originalInput: string = '';
    tokenCaller = 'rewards-partner';
    isError = false;
    freshPassUser = false;
    public isPartnerPromotionV2: boolean = false;
    pageSource: any;
    public errorMessage: string = "";

    constructor(public authService: AuthService,
                private rewardService: RewardService,
                private _rewardSummaryService: RewardsSummaryService,
                private paramService: ParamService) {
    }

    _init(): void {
        this.currentEnvironment = this._rewardSummaryService.getEnvironment();
        this.banner = this.paramService.banner;
        this.isPartnerPromotionV2 = properties.rewardsConfig.partnerPromotionV2[this.banner];
        this.appHostURL = this.authService.getApplicationDomainURL();
        this.pageSource = 'banner4u';
        if (!this.isPartnerPromotionV2) {
            this.getUserInfo();
        } else {
            this.getUserInfoV2();
            setTimeout(()=>{
                window.scrollTo(0,0);
            },1000)
        }
    }
    ngOnInit(): void {
       this._init();
    }

    getUserInfo() {
        this.authService.rewardPartnerSessionData$.subscribe((userInfo) => {
            if (userInfo) {
                this.userInfo = userInfo;
                if (userInfo.isTokenValid) {
                    this.selectedBanner = this.userInfo.banner;
                    this.isLoggedInTokenValid = true;
                    this.initSubscribe();
                    this.initPromosRendering();

                } else {
                    this.authService.redirectToSSO(userInfo.tokenObject);
                }
            } else {
                this.authService.getUserLogedInToken(this.tokenCaller);
            }
        });
    }

    getUserInfoV2() {
        this.authService.rewardPartnerSessionData$.subscribe((userInfo) => {
            if (userInfo) {
                this.userInfo = userInfo;
                this.selectedBanner = this.userInfo.banner;
                this.isLoggedInTokenValid = this.authService.isTokenValidForSession(this.userInfo);
                this.initPromosRenderingV2();
            } else {
                this.authService.getUserLogedInToken(this.tokenCaller);
            }
        });
    }

    initSubscribe() {
    }

    initPromosRendering() {
        this._rewardSummaryService.getFreshpassSubscription(this.currentEnvironment, this.userInfo).subscribe((data: any) => {
            if (data && data.Data) {
                this.freshPassUser = (data.Data.subscriptionStatus === 'ACTIVE' || data.Data.subscriptionStatus === 'TRIAL' || data.Data.subscriptionStatus === 'PENDING_CANCELLATION');
                this.getPartnerOffers(this.freshPassUser);
            }
        }, error => {
            this.getPartnerOffers(this.freshPassUser);
        });
    }

    initPromosRenderingV2() {
        this.getPartnerOffersV2();
    }

    showErrorScreen() {
        this.loading = false;
        this.isError = true;
    }

    handleErrorForPartnerAPI(error) {
        const defaultErrorMessage = "Due to some technical issues, we are unable to display partner offers at this time. Please check back soon or view our other deals.";

        if (error?.errors?.[0]) {
            const errorDetails = error.errors[0];
            if (errorDetails.code === "401 UNAUTHORIZED") {
                this.partnerOfferDeals = [];
                this.authService.redirectToSSO(this.userInfo.tokenObject);
            } else {
                this.errorMessage = defaultErrorMessage;
                this.showErrorScreen();
            }
        } else {
            this.errorMessage = defaultErrorMessage;
            this.showErrorScreen();
        }
    
        // Clear partner offers
        this.partnerOfferDeals = [];
    
        // Log error to data layer if available
        if (window['AB']?.DATALAYER) {
            window['AB']['DATALAYER'].setError('no-value', 'partner-offers|error', this.errorMessage);
        }
    }
    

    getPartnerOffers(freshPassUser) {
        this.rewardService.getPromotions(this.currentEnvironment, this.userInfo, this.banner).subscribe((promotionData: any) => {
                if (promotionData) {
                    let promoObjectList = [];
                    if (typeof (promotionData) == 'string') {
                        promotionData = JSON.parse(promotionData);
                        promoObjectList.push(promotionData)
                    } else {
                        promoObjectList = promotionData;
                    }
                    const respList: any = promoObjectList;
                    respList.forEach(promo => {
                        promo.isExpand = false;
                    });
                    respList.forEach((promotion: any, index: any) => {
                        if (promotion.bannerType === 'partnerBanner' && promotion.includedBanners.includes(this.userInfo.banner)) {
                            if (freshPassUser && (promotion.partnerProgramType === 'all' || promotion.partnerProgramType === 'freshpass')) {
                                this.partnerOfferDeals.push(promotion);

                            } else if (!freshPassUser && (promotion.partnerProgramType === 'b4u' || promotion.partnerProgramType === 'all')) {
                                this.partnerOfferDeals.push(promotion);
                            }

                        }
                    });
                    if (this.partnerOfferDeals) {
                        this.partnerOfferDeals.sort((partnerA, partnerB) => partnerB.displayOrder - partnerA.displayOrder);
                    }
                    this.analyticsPageLoad(this.partnerOfferDeals?.length > 0 ? 'prtnrs' : 'no-prtnrs');
                    this.loading = false;
                } else {
                    this.handleErrorForPartnerAPI(null);
                }
            }, error => {
                this.handleErrorForPartnerAPI(error.error);
            }
        );
    }

    getPartnerOffersV2() {
        this.rewardService.getPromotionsV2(this.currentEnvironment, this.userInfo, this.pageSource).subscribe((promotionData: any) => {
            if (promotionData.offers) {
                promotionData.offers.forEach((promo: any, index: any) => {
                    this.partnerOfferDeals.push(promo);
                })
                if (this.partnerOfferDeals) {
                    this.partnerOfferDeals.sort((partnerA, partnerB) => partnerB.displayOrder - partnerA.displayOrder);
                }
                this.loading = false;
            } else {
                this.partnerOfferDeals = [];
                this.loading = false;
                this.isError = false;
            }
            this.analyticsPageLoad(this.partnerOfferDeals?.length > 0 ? 'prtnrs' : 'no-prtnrs');
        }, error => {
            this.handleErrorForPartnerAPI(error.error);
        });
    }

    openDealsPage() {
        window.location.href = '/foru/coupons-deals.html'
    }

    analyticsPageLoad(impressions: string) {
        if (window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].initAngularSPA) {
            window['AB']['DATALAYER'].initAngularSPA('rewards', 'partners', undefined, undefined, impressions);
        }
    }

}
